<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/d21ZZK/tc-custom/9781455606511.jpg?1705319558079" alt="This image is the cover for the book Jade Stone"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jade Stone
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>“A tale of artistic integrity told with artful simplicity.”</i></b><br/>                                        — Kirkus Starred Review </p><p><b><i>“Visually it advances like the unrolling of an oriental scroll . . . A satisfying tale, whether read aloud or pored over alone to pick up the whimsical humor of the illustrations.”    </i></b><br/> —School Library Journal </p><p> When Chan is given a perfect jade stone and is commanded to carve a dragon from it, he senses a different destiny for the gem—and for himself. Perfect for middle readers and warmly illustrated by painter Ju-Hong Chen, this Chinese folktale offers a clear and gentle message of artistic truth and a lesson in staying true to one’s self. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Caryn Yacowitz, Ju Hong Chen
      </h2>
      
      <p class="authorDescription body article"><P> Author and playwright Caryn Yacowitz earned an MA in creative writing from San Francisco State University. She publishes poetry and non-fiction work for children on various subjects and teaches writing in northern California. </P><P> Ju-Hong Chen is a self-taught artist who grew up in Communist China. Purposely avoiding the training of China&#39;s art schools, he worked as an art designer in a factory. He moved to the United States in 1982 and his first picture book earned Parents&#39; Choice Honor Book for illustration. Chen lives in Oregon. </P><P> &#160; </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?50bf774a